

function UserCreation() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Membership.UserCreation visual. <br/>
   /// <br/>
    /// Author: AFU<br />
    /// Date: 7.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 7.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.validation = null;
}
UserCreation.prototype = new vcTemplate();
UserCreation.prototype.init = function () {
    /// <summary>
    /// This function sets the input field values and inits the clickhandler and js-based input validation
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        me.visual.find("#divWizard").vcWizard({'stepWidth':400});

        me.validation = new vcFormValidation(me.visual, me.visual.find("#divBtnSave"));

        me.visual.find('#divBtnSave').button().off("click").on("click", function () { me.btnSave();});

        me.visual.find('.formItem .input').off("change, keyup").on("change, keyup", function () {
            me.validation.validate($(this).attr("id"), me.itemInfo[$(this).attr("id")]);
        });
       
        me.visual.find('.formItem .input').each(function () {
            me.validation.validate($(this).attr("id"), me.itemInfo[$(this).attr("id")]);
        });

       // me.visual.find(".formItem :select").off("change").on("change", function() { me.validation.checkValidState() });
        me.visual.find('#divBtnSave').button("disable");
    
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};


UserCreation.prototype.btnSave = function () {
    /// <summary>
    /// Handles the click of the save button - first, it only checks the username <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        if (me.visual.find("#divBtnSave").button("option", "disabled")) {return false}
      
        var param = {}
        // param.ID = me.ID;
        param.TitleID = me.visual.find("#ddlTitle").val();
        param.firstname = me.visual.find("#txtFirstname").val();
        param.lastname = me.visual.find("#txtLastname").val();
        param.username = me.visual.find("#txtUsername").val();
        param.email = me.visual.find("#txtEmail").val();
        param.description = me.visual.find("#txtDescription").val();
       // param.isLockedOut = me.visual.find("#chbIsLockedOut").prop("checked");
        me.checkUsername(param);
        return true;
    } catch (ex) {
        me.writeError('btnSave', ex);
        return false;
    }
};


UserCreation.prototype.checkUsername = function (param) {
    /// <summary>
    /// Validates the username<br/>
    /// If everything is ok it saves the data.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", me.deviceType, me.langid, JSON.stringify(param), function (result) {
          
            if (result === null) {
                me.showMessage(me.resources.err_loadData, true);
                return false;
            }
            if (result === false) {
                me.showInfo(me.resources.username_exists, "", true);
                
            } else {
                me.save(param);
            
          }
            return true;
        });
        return true;
    } catch (ex) {
        me.writeError('checkUsername', ex);
        return false;
    }
};


UserCreation.prototype.save = function (param) {
    /// <summary>
    /// Saves the data.<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
       window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", me.deviceType, me.langid, JSON.stringify(param), function (result) {
           
           if (result === null) {
               me.showMessage(me.resources.err_saveData, true);
               return false;
           }
           if (result.ErrorState === true || result.ID === -1) {
               me.showMessage(me.resources.err_saveData, true);
               return false;
           }
           me.uid = result.ID;
           me.showInfo("", "", false);
           me.initStep2();
           return true;
        });
       return true;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }
};


UserCreation.prototype.initStep2 = function () {
    /// <summary>
    /// Saves the data.<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find("#divWizard").vcWizard("setActive", 1);
        me.visual.find("#divFormStep1").hide();
        me.visual.find("#divFormStep2").show();
        me.vcVisual.addVisualBaseByName('divForm', 'VISUAL_MEMBERSHIP_USER_DETAILS', 'Step2', getCurrentTimestamp(), parseInt(me.visual.find("#divFormStep2").height(), 10), parseInt(me.visual.find("#divFormStep2").width(), 10), JSON.stringify({ "id": me.uid,"Creation":true }), '', me.deviceType);

        return true;

    } catch (ex) {
        me.writeError('initStep2', ex);
        return false;
    }
};


